import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import NutritionFact from './nutrition-fact';
import styles from './styles.cssm';
import messages from './messages';

const disclaimerTitleId = 'disclaimerTitleId';

const NutritionTable = ({
  nutrition,
  nutritionHeadingId,
  showCaloriesFromFat,
}) => {
  const { formatMessage } = useIntl();
  const { calories, caloriesFromFat, additionalFacts } = nutrition;
  const [showCaffeineDisclaimer, setShowCaffeineDisclaimer] = useState(false);
  const caffeineDisclaimerId = 'caffeineDisclaimer';
  const caffeineElementId = 'caffeineElement';

  useEffect(() => {
    const hasCaffeine = additionalFacts.some(
      (fact) =>
        fact?.displayName === 'Caffeine' || fact?.displayName === 'Caféine'
    );
    if (hasCaffeine) {
      setShowCaffeineDisclaimer(true);
    }
  }, [additionalFacts]);

  const factsTable = additionalFacts.map((fact, index) => (
    <NutritionFact
      caffeineDisclaimerId={caffeineDisclaimerId}
      caffeineElementId={caffeineElementId}
      disclaimerTitleId={disclaimerTitleId}
      fact={fact}
      key={fact?.id ?? index}
    />
  ));

  const OuterTagName = showCaloriesFromFat ? 'ul' : 'span';
  const InnerTagName = showCaloriesFromFat ? 'li' : 'span';

  return (
    <div data-e2e="nutritionTable">
      <ul>
        <li className={styles.calories}>
          <OuterTagName className="flex justify-between">
            <InnerTagName className={`text-semibold`}>
              <span className="pr1">{calories.displayName}</span>
              <span>{calories.displayValue}</span>
            </InnerTagName>
            {showCaloriesFromFat && (
              <li className={`text-semibold pl2 whiteSpace-noWrap`}>
                <span className="pr1">{caloriesFromFat.displayName}</span>
                <span>{caloriesFromFat.displayValue}</span>
              </li>
            )}
          </OuterTagName>
        </li>
        {factsTable}
      </ul>

      <h3 className="hiddenVisually" id={disclaimerTitleId}>
        {formatMessage(messages.disclaimerHeading)}
      </h3>

      <ul className="color-textBlackSoft">
        <li className="mt3">{formatMessage(messages.dailyValuesDisclaimer)}</li>
        {showCaffeineDisclaimer ? (
          <li
            className={`mt3 ${styles.offset} ${styles.target}`}
            id={caffeineDisclaimerId}
          >
            {formatMessage(messages.caffeineDisclaimer)}
            <a
              aria-describedby={nutritionHeadingId}
              aria-label={formatMessage(messages.backToContent)}
              className="text-noUnderline"
              href={`#${caffeineElementId}`}
            >
              ↩
            </a>
          </li>
        ) : null}
        <li className="mt3">
          {formatMessage(messages.generalNutritionDisclaimer)}
        </li>
      </ul>
    </div>
  );
};

export default NutritionTable;
